import React, { useMemo } from 'react';

interface RTLWrapperProps {
  languageCode?: string;
  children: React.ReactNode;
}

export const RTLWrapper: React.FC<RTLWrapperProps> = ({ languageCode, children }) => {
  // Typical RTL languages in the region
  const isRTL = useMemo(() => {
    if (!languageCode) return false;
    const rtlCodes = ['ar', 'he', 'fa', 'ur'];
    return rtlCodes.includes(languageCode.toLowerCase());
  }, [languageCode]);

  return (
    <div 
      dir={isRTL ? 'rtl' : 'ltr'} 
      className={isRTL ? 'font-arabic' : 'font-sans'}
    >
      {children}
    </div>
  );
};
